import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/icons/Logo';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { SunIcon, MoonIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

const TermsOfService: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { language, setLanguage } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      {/* Theme and Language Selectors */}
      <div className="absolute top-4 right-4 z-20 flex items-center space-x-3">
        {/* Theme Selector */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm hover:bg-white/90 dark:hover:bg-gray-800/90 transition-all duration-200 shadow-md"
          aria-label={theme === 'light' ? 'Váltás sötét módra' : 'Váltás világos módra'}
        >
          {theme === 'light' ? (
            <MoonIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          ) : (
            <SunIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          )}
        </button>

        {/* Language Selector */}
        <button
          onClick={() => setLanguage(language === 'hu' ? 'en' : 'hu')}
          className="p-2 rounded-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm hover:bg-white/90 dark:hover:bg-gray-800/90 transition-all duration-200 shadow-md flex items-center space-x-1"
          aria-label={language === 'hu' ? 'Switch to English' : 'Váltás magyarra'}
        >
          <GlobeAltIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300 uppercase">
            {language === 'hu' ? 'EN' : 'HU'}
          </span>
        </button>
      </div>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <Link to="/">
            <Logo className="h-16 mx-auto" showCompanyName={false} />
          </Link>
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-white">Felhasználási Feltételek</h1>
        </div>
        
        <div className="bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6 prose dark:prose-invert max-w-none text-gray-900 dark:text-gray-100">
            <h2>1. Bevezetés</h2>
            <p>
              Üdvözöljük a YouCRM-ben! Ezek a Felhasználási Feltételek 
              szabályozzák a CRM rendszerünk használatát és az általunk nyújtott szolgáltatásokat. A szolgáltatások 
              elérésével vagy használatával Ön elfogadja, hogy ezek a feltételek kötelezőek Önre nézve.
            </p>
            
            <h2>2. Hozzáférés és használat</h2>
            <p>
              Ez a rendszer érzékeny üzleti információkat tartalmaz, és csak jogosult személyek férhetnek hozzá. 
              A rendszer jogosulatlan elérése vagy használata szigorúan tilos.
            </p>

            <h2>3. Fiók biztonsága</h2>
            <p>
              Ön felelős a fiókja hitelesítő adatainak bizalmas kezeléséért. Minden, az Ön fiókja alatt 
              történő tevékenységért Ön a felelős.
            </p>

            <h2>4. Adatvédelem</h2>
            <p>
              Megfelelő biztonsági intézkedéseket hajtunk végre az Ön adatainak védelme érdekében. Az adatkezelésünkről 
              további információkat az <Link to="/privacy-policy" className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300">Adatvédelmi Szabályzatban</Link> találhat.
            </p>

            <h2>5. Szolgáltatás elérhetősége</h2>
            <p>
              Törekszünk a folyamatos szolgáltatásnyújtásra, de nem garantálhatjuk, hogy a szolgáltatás mindig elérhető lesz. 
              Fenntartjuk a jogot a szolgáltatás felfüggesztésére vagy megszüntetésére karbantartás vagy egyéb okok miatt.
            </p>

            <h2>6. Felelősség korlátozása</h2>
            <p>
              A YouCRM nem vállal felelősséget semmilyen közvetett, véletlen, különleges, következményes vagy 
              büntető jellegű kárért, amely a szolgáltatás használatából vagy annak használatára való képtelenségből ered.
            </p>

            <div className="mt-8 text-center">
              <Link to="/login" className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300">
                Vissza a bejelentkezéshez
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 